import "./OurCatalogue.module.css";
import Header from "@/reusable_sections/Header";
import TrademarkPortfolio from "./sections/TrademarkPortfolio";
import CustomSourcing from "./sections/CustomSourcing";
import Footer from "@/reusable_sections/Footer";
export default function OurCataloguePage() {
  return <div>
      <Header />
      <TrademarkPortfolio />
      <CustomSourcing />
      <Footer />
    </div>;
}